import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-pendingorders',
  templateUrl: './pendingorders.component.html',
  styleUrls: ['./pendingorders.component.css']
})
export class PendingordersComponent extends BaseCrudComponent {

  	translations:any;
	header:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    zones:any;
    old:any;

    offline_key_list = 'PENDING_ORDERS';
    offline_key_zones = 'ZONES';
    offline_date = '';

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private datePipe: DatePipe
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportPendingOrders/Post';
        this.header = {};
        this.zones = [];
        this.old = [];

        this.srv.offline.subscribe(r => {
            this.isOffline = r;
        });
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;

        obj = {
            Zone: null,
            Date: this.f_datefrom + '-01'
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        if(this.isOffline){
            this.srv.getOfflineData(this.offline_key_list).then(x => {
                //console.log(x);
                var rs = x.data;
                if( (rs != null) && (rs != undefined) ){
                    this.header = rs.header;
                    this.parseDetails(rs.detailActual, 'actual');
                    this.parseDetails(rs.detailPast, 'old');
                    this.offline_date = x.last_update;
                }
            });
        }
        else{
            this.loadingList = true;
            //console.log(obj);

            this.srv.postCall(qst, obj).subscribe(x => {
                this.loadingList = false;

                if(x.status){
                    var rs = x.data;
                    this.srv.saveOfflineData(this.offline_key_list, rs);
                    this.header = rs.header;
                    this.parseDetails(rs.detailActual, 'actual');
                    this.parseDetails(rs.detailPast, 'old');
                }
            });
        }
    }

    parseDetails(rs:any, ref:any){
    	var rows:any;
    	var tmp:any;
    	var tobj:any;

    	if( ref == 'old' ){
    		this.old = [];
    		rows = this.old;
    	}
    	else{
    		this.rows = [];
    		rows = this.rows;
    	}
    	
    	//this.rawdata = [];
    	
    	rs.forEach(x => {
    		tmp = {};
    		tmp.abc = x.abc;
    		tmp.cliente = x.cliente;
    		tmp.factura = x.factura;
    		tmp.fecha = x.fecha;
            tmp.fechaAurora = x.dFechaAurora;
            tmp.fechaSAP = x.dFechaSAP;
    		tmp.fechaDespacho = x.fechaDespacho;
    		tmp.fechaFactura = x.fechaFactura;
    		tmp.fechaLiberaContado = x.fechaLiberaContado;
    		tmp.fechaLiberaCredito = x.fechaLiberaCredito;
    		tmp.fechaLiberaVentas = x.fechaLiberaVentas;
    		tmp.fechaPicking = x.fechaPicking;
    		tmp.guia = x.guia;
    		tmp.idAgente = x.idAgente;
    		tmp.idCliente = x.idCliente;
    		tmp.idSupervidor = x.idSupervidor;
    		tmp.pedidoAurora = x.pedidoAurora;
    		tmp.pedidoSap = x.pedidoSap;
            tmp.ptoExpedicion = x.ptoExpedicion;
    		tmp.zona = x.zona;
            tmp.transporte = x.transporte;
            tmp.bloqueo = x.bloqueo;

    		//this.rawdata.push(tmp);
    		rows.push(tmp);
    	});

    	//ref = this.rawdata;
    	//console.log(rows);
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        if(this.isOffline){
            //return of(false);
            return from( this.srv.getOfflineData(this.offline_key_zones).then(x => {
                if( x != null ){
                    return x.data;
                }
                else{
                    return false;
                }
            }) );
        }
        else{
            return this.srv.getCall(par_url).pipe(
                        mergeMap(data => {
                            let mydata:any = {status: false, data: [], message: ''};
                            mydata = data;
                            //console.log(data);
                            
                            if( mydata.status ){
                                this.srv.saveOfflineData(this.offline_key_zones, mydata.data);
                                return of(mydata.data);
                            }
                            else{
                                return of(false);
                            }
                          }),
                          //timeout(MAX_TIME),
                          catchError(data => {return of(false)})
                    );
        }
    }

    getPdfReportHeader(){
        var obj = [];

        obj.push([{content:'REPORTE PEDIDOS PENDIENTES', colSpan:4, styles:{fontStyle:'bold', halign:'center'}}]);
        obj.push([
            {content:'Zona: ', colSpan:2},
            {content:'Fecha: ' + this.today, colSpan:2}
        ]);
        obj.push([
            {content:'Vendedor: ' + this.header['agent'], colSpan:2},
            {content:'Mes: ' + this.curr_date, colSpan:2}
        ]);
        obj.push([
            {content:'Supervisor: ' + this.header['supervisor'], colSpan:2},
            {content:'', colSpan:2}
        ]);

        return obj;
    }

    exportReport(){
        var doc = new jsPDF('l','pt', 'a4');
        autoTable(doc, {body: this.getPdfReportHeader(), theme:'grid'});

        let header = [];
        let footer = [];
        let x = [];

        //Today Orders
        header = [];
        header.push([{content:'PEDIDOS DEL DIA', colSpan:18, styles:{fontStyle:'bold', halign:'center', fontSize:10}}]);
        header.push(['CLIENTE', 'COD_CLIENTE', 'ABC', 'F_AURORA', '# PEDIDO_AURORA', 'F_SAP', '# PEDIDO_SAP', 'PTO EXPEDICION', 'BLOQUEO', 'F_LIBERA_CONT', 'F_LIBERA_VENTAS', 'F_LIBERA_CRED', 'F_PICKING', 'F_FACTURA', '# FACTURA', 'F_DESPACHO', 'TRANSPORTISTA', 'No. GUIA']);
        
        x = [];
        this.rows.forEach(i => {
            x.push([
                i.cliente,
                i.idCliente,
                i.abc,
                i.fechaAurora,
                i.pedidoAurora,
                i.fechaSAP,
                i.pedidoSap,
                i.ptoExpedicion,
                i.bloqueo,
                i.fechaLiberaContado,
                i.fechaLiberaVentas,
                i.fechaLiberaCredito,
                i.fechaPicking,
                i.fechaFactura,
                i.factura,
                i.fechaDespacho,
                i.transporte,
                i.guia
            ]);
        });

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fontSize:5, fillColor:'#3e5569'}, bodyStyles:{fontSize:5}, footStyles:{fontSize:5, fillColor:'#e9ecef', textColor:'#000'}});

        //Past Orders
        header = [];
        header.push([{content:'PEDIDOS DIAS ANTERIORES', colSpan:18, styles:{fontStyle:'bold', halign:'center', fontSize:10}}]);
        header.push(['CLIENTE', 'COD_CLIENTE', 'ABC', 'F_AURORA', '# PEDIDO_AURORA', 'F_SAP', '# PEDIDO_SAP', 'PTO EXPEDICION', 'BLOQUEO', 'F_LIBERA_CONT', 'F_LIBERA_VENTAS', 'F_LIBERA_CRED', 'F_PICKING', 'F_FACTURA', '# FACTURA', 'F_DESPACHO', 'TRANSPORTISTA', 'No. GUIA']);
        x = [];
        this.old.forEach(i => {
            x.push([
                i.cliente,
                i.idCliente,
                i.abc,
                i.fechaAurora,
                i.pedidoAurora,
                i.fechaSAP,
                i.pedidoSap,
                i.ptoExpedicion,
                i.bloqueo,
                i.fechaLiberaContado,
                i.fechaLiberaVentas,
                i.fechaLiberaCredito,
                i.fechaPicking,
                i.fechaFactura,
                i.factura,
                i.fechaDespacho,
                i.transporte,
                i.guia
            ]);
        });

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fontSize:5}, bodyStyles:{fontSize:5}, footStyles:{fontSize:5, fillColor:'#e9ecef', textColor:'#000'}});

        //Page Header and Footer
        doc = this.addPagesHeaderAndFooter(doc);
        doc.save('pedidos_pendientes_' + this.curr_date);
    }

    addPagesHeaderAndFooter(doc:any) {
        var totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(Global.logo_base64, 'PNG', 710, 10, 90, 20);

            // Footer
            var str = 'Página ' + i + ' de ' + totalPages;
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, 40, pageHeight - 10);
        }

        return doc;
    }

}
